const hasAccess = (user, module) => {
  if (!user) {
    return false;
  }

  if (!user.role) {
    return false;
  }

  if (!Array.isArray(user.role.access)) {
    return false;
  }

  return user.role.access.includes(module);
};

export default hasAccess;
